<template>
  <div class="btn-wrapper">
    <a :href="program.url" target="_blank">
      <div class="icon">
        <img :src="$options.filters.setButtonIcon(program.tool, liveType)" alt="">
      </div>
      <div class="label">
        {{ program.tool | setButtonLabel(liveType) }}
      </div>
    </a>
  </div>
</template>

<script>
export default {
  props: {
    program: {
      type: Object,
      required: true
    },
    liveType: {
      type: String
    }
  },
  filters: {
    setButtonIcon (tool, liveType) {
      if (liveType === 'provider') {
        if (tool === '1') {
          return '/img/tools/instagram.png'
        } else if (tool === '2') {
          return '/img/tools/youtube.png'
        } else if (tool === '3') {
          return '/img/tools/zoom.png'
        } else if (tool === '4') {
          return '/img/tools/zoom.png'
        } else if (tool === '5') {
          return '/img/tools/zoom.png'
        }
      } else if (liveType === 'company') {
        if (tool === '1') {
          return '/img/tools/instagram.png'
        } else if (tool === '2') {
          return '/img/tools/zoom.png'
        } else if (tool === '3') {
          return '/img/tools/youtube.png'
        }
        return ''
      }
      return ''
    },
    setButtonLabel (tool, liveType) {
      if (liveType === 'provider') {
        if (tool === '1') {
          return 'インスタグラムで視聴する'
        } else if (tool === '2') {
          return 'YouTubeで視聴する'
        } else if (tool === '3') {
          return 'Zoomで視聴する'
        } else if (tool === '4') {
          return 'Zoomで視聴する'
        } else if (tool === '5') {
          return 'Zoomで視聴する'
        }
        return ''
      } else if (liveType === 'company') {
        if (tool === '1') {
          return 'インスタグラムで視聴する'
        } else if (tool === '2') {
          return 'Zoomで視聴する'
        } else if (tool === '3') {
          return 'YouTubeで視聴する'
        }
        return ''
      }
      return ''
    }
  }
}
</script>

<style lang="sass" scoped>
.btn-wrapper
  width: 100%
  max-width: 320px
  margin: 0 auto
  a
    display: flex
    justify-content: center
    align-items: center
    width: 100%
    height: 56px
    color: $black
    background-color: #fff
    border-radius: 8px
    box-shadow: 0 2px 8px rgba(0, 0, 0, .2)
    font-size: 1.6rem
    font-weight: bold
    img
      width: 32px
      margin-right: 5px
</style>
